<template>
  <div class="mask">
    <div class="chat-box">
      <div class="chat-tit">
        <span class="chat-name">{{ friendInfo.friend_name }}</span>
        <span class="el-icon-close" style="font-size: 17px" @click="close"></span>
      </div>
      <div class="chat-center">
        <div class="chat-left-list">
          <ul>
            <li
              v-for="(item, index) in chatUserList"
              :class="{ 'act-bg': friendInfo.friend_name == item.to_user_nickname }"
              @click="changeChat(item)"
            >
              <img :src="item.to_head_img" alt="" class="pic" />
              <div class="list-right">
                <div class="list-right-top">
                  <span class="h">{{ item.to_user_nickname }}</span>
                  <!-- <span class="t">{{newMessage.create_time.slice(0,10)}}</span> -->
                </div>
                <span class="c" v-if="item.new.type == 'txt'">{{
                  renderTxt(item.new.content)
                }}</span>
                <span class="c" v-if="item.new.type == 'img'">{{ $t("图片") }}</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="chat-right">
          <div class="chat-right-top" id="gundong">
            <!-- <div class="time">
                  2019-06-06 13:00
                </div> -->
            <!-- <template v-for="(item,index) in messageList">
              <template v-if="item.msgType=='txt'">
                <div class="chat-desc right" v-if="item.bySelf">
                  <img :src="userInfo.head_img" alt="" class="avapic">
                  <div class="text-boxs" v-html="renderTxt(item.info)"></div>
                </div>
                <div class="chat-desc" v-else>
                  <img :src="friendInfo.friend_img" alt="" class="avapic">
                  <div class="text-box" v-html="renderTxt(item.info)"></div>
                </div>
              </template>

              <template v-if="item.msgType=='img'">
                <div class="chat-desc " :class="{'right':item.bySelf}">
                  <img :src="item.bySelf?userInfo.head_img:friendInfo.friend_img" alt="" class="avapic">
                  <div :class="[item.bySelf?'margin-r-12':'margin-l-12']">
                    <img :key="item.info" :src="item.info ? item.info : ''" class="img-style" />
                  </div>
                </div>
              </template>
            </template> -->

            <template v-for="(item, index) in messageList">
              <template v-if="item.type == 'txt'">
                <div class="chat-desc right" v-if="item.to_user_id != userId">
                  <img :src="userInfo.head_img" alt="" class="avapic" />
                  <div class="text-boxs" v-html="renderTxt(item.content)"></div>
                </div>
                <div class="chat-desc" v-else>
                  <img :src="friendInfo.friend_img" alt="" class="avapic" />
                  <div class="text-box" v-html="renderTxt(item.content)"></div>
                </div>
              </template>

              <template v-if="item.type == 'img'">
                <div class="chat-desc" :class="{ right: item.to_user_id != userId }">
                  <img
                    :src="
                      item.to_user_id != userId
                        ? userInfo.head_img
                        : friendInfo.friend_img
                    "
                    alt=""
                    class="avapic"
                  />
                  <div
                    :class="[item.to_user_id != userId ? 'margin-r-12' : 'margin-l-12']"
                  >
                    <img
                      :key="item.content"
                      :src="item.content ? item.content : ''"
                      class="img-style"
                    />
                  </div>
                </div>
              </template>
            </template>
          </div>
          <div class="chat-right-bottom">
            <div class="set-box">
              <div class="set-img-box" @click="openemj">
                <img src="../imgs/icon.png" alt="" />
                <span style="font-size: 12px">{{ $t("表情") }}</span>
              </div>
              <div class="set-img-box" @click="clickFile">
                <img src="../imgs/update.png" alt="" />
                <span style="font-size: 12px">{{ $t("图片") }}</span>
                <input type="file" class="hide" ref="imgDom" @change="pictureChange" />
              </div>
            </div>
            <ChatEmoji
              v-on:selectEmoji="selectEmoji"
              :inpMessage="inputMessage"
              ref="emj"
            />

            <!-- <UpLoadImage :type="this.type"  /> -->
            <div class="btn-box">
              <!-- 表情组件 -->
              <el-input
                maxlength="30"
                type="textarea"
                rows="4"
                v-model="inputMessage"
                @keyup.enter.native="sendMessage"
                placeholder=" "
              />

              <!-- <textarea name="" id="" cols="30" rows="10" v-model="inputMessage" ></textarea> -->
              <div class="btn" @click="sendMessage">{{ $t("发送") }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UpLoadImage from "./upLoadImage/index.vue";
import websdk from "easemob-websdk";
import { conn } from "../utils/WebIM.js";
import ChatEmoji from "./chatEmoji/index.vue";
import emoji from "../utils/emoji";
import Service from "@/api/request/index.js";

//格式化时间
// import {formatDate} from '../../../assets/utils/format.js';
export default {
  name: "IMChat",
  components: {
    ChatEmoji,
    UpLoadImage,
  },
  props: {
    friendInfo: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      inputMessage: "",
      messageList: [], //消息
      userInfo: {},
      userId: "",
      type: "",
      page: 1,
      newMessage: "",
      chatUserList: [],
    };
  },

  created() {
    // this.loginIM();
    this.userInfo = JSON.parse(localStorage.getItem("USER_INFO"));
    console.log(this.userInfo, "okok");
    this.userId = "hafa" + this.userInfo.id;
    this.getChatList();
    this.getChatUserList();

    this.getMessage();

    // this.getImgMessage()

    console.log(this.friendInfo);
  },

  methods: {
    changeChat(item) {
      console.log(item, "sosoos");
      console.log(this.friendInfo, "sosoos");

      this.friendInfo.friend_id = "hafa" + item.to_user_id;
      this.friendInfo.friend_name = item.to_user_nickname;
      this.friendInfo.friend_img = item.to_head_img;
      this.getChatList();
      this.getMessage();
    },
    openemj() {
      this.$refs.emj.open();
    },

    selectEmoji(v) {
      this.inputMessage = v;
      // this.$refs.txtDom.focus();
    },

    customEmoji(value) {
      return `<img src="../../../static/faces/${value}" style="width:20px"/>`;
    },

    renderTxt(txt = "") {
      let rnTxt = [];
      let match = null;
      const regex = /(\[.*?\])/g;
      let start = 0;
      let index = 0;
      while ((match = regex.exec(txt))) {
        index = match.index;
        if (index > start) {
          rnTxt.push(txt.substring(start, index));
        }
        if (match[1] in emoji.obj) {
          const v = emoji.obj[match[1]];
          rnTxt.push(this.customEmoji(v));
        } else {
          rnTxt.push(match[1]);
        }
        start = index + match[1].length;
      }
      rnTxt.push(txt.substring(start, txt.length));
      return rnTxt.toString().replace(/,/g, "");
    },

    close() {
      console.log("opopsoposdp");
      this.$emit("closechat");
    },

    getChatUserList() {
      Service.post63687a04ce172({}).then((res) => {
        console.log("ssssdddd", res);
        if (res.code == 1) {
          this.chatUserList = res.data;
        }
      });
    },

    getChatList() {
      console.log(this.$store.state.msgList, "ldjjjjjss");

      let key = this.friendInfo.friend_id + "_" + this.userId;

      console.log(key);

      Service.post63687c01c5bfe({
        page: this.page,
        to_user_id: this.friendInfo.friend_id,
      }).then((res) => {
        console.log("ssssdddd", res);
        if (res.code == 1) {
          this.newMessage = res.data.data[0];

          this.messageList = res.data.data.reverse();

          this.messageList.forEach((item) => {
            item.to_user_id = "hafa" + item.to_user_id;
          });
        }

        let msg = document.getElementById("gundong"); // 获取对象

        msg.scrollTop = msg.scrollHeight; // 滚动高度

        this.getChatUserList();
      });

      // if (this.$store.state.msgList[key]) {
      //   this.messageList = this.$store.state.msgList[key]
      // } else {
      //   this.messageList = []
      // }

      // localStorage.setItem('msgList',JSON.stringify(this.$store.state.msgList))
    },

    clickFile() {
      console.log("oooooooiiii");
      let img = this.$refs.imgDom;
      img && img.click();
    },
    // 发送图片
    pictureChange(e) {
      console.log(e);
      let file = WebIM.utils.getFileUrl(e.target);

      let allowType = {
        jpg: true,
        gif: true,
        png: true,
        bmp: true,
      };

      console.log(file, "poopopo");
      if (!file.filename) {
        this.$refs.imgDom.value = null;
        return false;
      }
      // if (!Config.imgType[file.filetype.toLowerCase()]) {
      //   this.$refs.imgDom.value = null;
      //   this.$message.error("不支持此类型文件");
      //   return;
      // }
      if (file.filetype.toLowerCase() in allowType) {
        let obj = {
          file: file,
          // roomType: isRoom,
          callback: () => {
            this.$refs.imgDom.value = null;
          },
        };

        this.sendImgMessage(obj);
      } else {
        this.$message.error(this.$t("请上传图片"));
      }
    },

    sendImgMessage(payload) {
      const { file, callback } = payload;
      const id = WebIM.conn.getUniqueId();
      let toID = this.friendInfo.friend_id;
      const msgObj = new WebIM.message("img", id);
      let that = this;

      msgObj.set({
        file: file,
        to: toID,
        chatType: "singleChat",
        onFileUploadError: function (error) {
          console.log("图片上传失败", error);
          callback();
        },
        onFileUploadComplete: function (data) {
          let url = data.uri + "/" + data.entities[0].uuid;
          const time = +new Date();

          let queryParams = {
            to_im_id: that.friendInfo.friend_id,
            type: "img",
            content: url,
          };

          Service.post63687667584ca(queryParams).then((res) => {
            console.log("ssssdddd", res);
            if (res.code == 1) {
              that.$store.commit("updateMsgList", {
                msg: url,
                chatType: "singleChat",
                bySelf: true,
                time: time,
                id: conn.getUniqueId(),
                // toID:this.friendInfo.friend_id,
                chatId: that.friendInfo.friend_id + "_" + that.userId,
                from: "hafa" + that.userInfo.id,
                info: url,
                msgType: "img",
              });
            }
          });

          callback();
        },
        success: function () {
          console.log("图片发送成功");
          that.getChatList();

          that.$nextTick(() => {
            let msg = document.getElementById("gundong"); // 获取对象

            console.log(msg.scrollHeight, "okokok");

            msg.scrollTop = msg.scrollHeight; // 滚动高度
          });
        },
      });

      // if(chatType === 'group' || chatType === 'chatroom'){
      // 	msgObj.setGroup('groupchat');
      // }
      WebIM.conn.send(msgObj.body);
    },

    //发送消息
    sendMessage() {
      console.log(this.userInfo.head_img);

      if (!this.inputMessage || !this.inputMessage.replace(/&nbsp;|\s/g, "")) {
        this.$message.info(this.$t("发送内容不能为空!"));
        return;
      }
      let that = this;
      let contentMsg = that.inputMessage;
      let toID = this.friendInfo.friend_id; //收信息用户id
      let id = conn.getUniqueId(); // 生成本地消息id
      let msg = new WebIM.message("txt", id); // 创建文本消息
      msg.set({
        msg: contentMsg, // 消息内容
        to: toID, // 接收消息对象（用户id）
        chatType: "singleChat", // 设置为单聊
        success: function (id, serverMsgId) {
          console.log("成功发送消息");

          that.sendMessageSuccessful(contentMsg, toID, "txt");
        },
        fail: function (e) {
          console.log("发送消息失败");
        },
      });
      conn.send(msg.body);
      that.inputMessage = null;
    },
    //成功发送消息，进行消息加入到聊天信息数组中
    sendMessageSuccessful(data, toID, type) {
      console.log("存储信息中》》》》》", toID);
      // let userMsg={};
      // userMsg.to=toID;
      // userMsg.from='hafa' + this.userInfo.id;
      // userMsg.info=data;
      // // userMsg.time=formatDate(new Date(new Date().getTime()),'yyyy-MM-dd hh:mm');
      // userMsg.msgType=type;
      //          userMsg.bySelf = true
      const time = +new Date();
      //存储信息
      // this.messageList.push(userMsg);

      let queryParams = {
        to_im_id: this.friendInfo.friend_id,
        type: type,
        content: data,
      };

      console.log(Service.post63687667584ca);

      Service.post63687667584ca(queryParams).then((res) => {
        console.log("ssssdddd", res);
        if (res.code == 1) {
          this.$store.commit("updateMsgList", {
            msg: data,
            chatType: "singleChat",
            bySelf: true,
            time: time,
            id: conn.getUniqueId(),
            // toID:this.friendInfo.friend_id,
            chatId: this.friendInfo.friend_id + "_" + this.userId,
            from: "hafa" + this.userInfo.id,
            info: data,
            msgType: type,
          });
          this.getChatList();
        }
      });
      // this.$nextTick(() => {
      let msg = document.getElementById("gundong"); // 获取对象

      console.log(msg, "okokok");

      msg.scrollTop = msg.scrollHeight; // 滚动高度
      // })

      console.log(this.messageList);
    },

    getImgMessage() {
      let that = this;
      conn.listen({
        onOpened: function (message) {
          console.log("用户已上线"); // 连接成功
        },
      });
    },
    // 集成收到文本信息方法
    getMessage() {
      let that = this;
      conn.listen({
        onOpened: function (message) {
          console.log("用户已上线"); // 连接成功
        },
        onTextMessage: function (message) {
          console.log("收到文本信息");
          console.log(message);
          const time = +new Date();
          // let date = formatDate(new Date(new Date().getTime()),'yyyy-MM-dd hh:mm');
          let value = {};
          // 普通文本信息
          // value = {
          //   type: 'txt',
          //   info: message.data,
          //   to: message.to,
          //   from: message.from,
          //   time: time,
          //   chatId: that.friendInfo.friend_id + '_' + that.userId,
          //   toID: that.friendInfo.friend_id,
          //   bySelf: false,
          //   id: message.id
          // }

          let queryParams = {
            to_im_id: that.userId,
            type: "txt",
            content: message.data,
          };

          Service.post63687667584ca(queryParams).then((res) => {
            console.log("ssssdddd", res);
            if (res.code == 1) {
              that.getChatList();
            }
          });

          // value = {
          //   type: 'txt',
          //   content: message.data,
          //   to_user_id: that.userId,
          //   from: message.from,
          //   time: time,
          //   chatId: that.friendInfo.friend_id + '_' + that.userId,
          //   toID: that.friendInfo.friend_id,
          //   bySelf: false,
          //   id: message.id
          // }
          // that.messageList.push(value) // 添加到聊天信息数组中

          that.$nextTick(() => {
            let msg = document.getElementById("gundong"); // 获取对象
            msg.scrollTop = msg.scrollHeight; // 滚动高度
          });

          console.log(that.messageList);
        },
        onPictureMessage: function (message) {
          console.log("收到图片信息");
          console.log(message);
          const time = +new Date();
          // let date = formatDate(new Date(new Date().getTime()),'yyyy-MM-dd hh:mm');
          // let value = {}
          // 普通文本信息
          // value = {
          //   msgType: 'img',
          //   info: message.url,
          //   to: message.to,
          //   from: message.from,
          //   time: time,
          //   chatId: that.friendInfo.friend_id + '_' + that.userId,
          //   toID: that.friendInfo.friend_id,
          //   bySelf: false,
          //   id: message.id
          // }

          // value = {
          //   type: 'img',
          //   content: message.url,
          //   to_user_id: that.userId,
          //   from: message.from,
          //   time: time,
          //   chatId: that.friendInfo.friend_id + '_' + that.userId,
          //   toID: that.friendInfo.friend_id,
          //   bySelf: false,
          //   id: message.id
          // }

          // that.messageList.push(value) // 添加到聊天信息数组中

          let queryParams = {
            to_im_id: that.userId,
            type: "img",
            content: message.url,
          };

          Service.post63687667584ca(queryParams).then((res) => {
            console.log("ssssdddd", res);
            if (res.code == 1) {
              that.getChatList();
            }
          });

          that.$nextTick(() => {
            let msg = document.getElementById("gundong"); // 获取对象
            msg.scrollTop = msg.scrollHeight; // 滚动高度
          });

          // console.log(that.messageList)
        },
      });
    },
  },
};
</script>

<style>
.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

.chat-box {
  width: 1200px;
  height: 667px;
  background: pink;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
}

.chat-tit {
  display: flex;
  width: 100%;
  height: 94px;
  background: #ffffff;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
}

.chat-name {
  font-size: 22px;
  font-weight: bold;
}

.chat-center {
  display: flex;
  width: 100%;
  height: 573px;
  background: #f3f3f3;
}

.chat-left-list {
  width: 302px;
  height: 100%;
  background: #ffffff;
  overflow-y: scroll;
}

.chat-right {
  width: 897px;
  height: 100%;
}

.chat-right-top {
  width: 100%;
  height: 403px;
  /* background: pink; */
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow-y: scroll;
}

.chat-left-list ul {
  width: 100%;
  height: 100%;
}

.chat-left-list ul li {
  width: 100%;
  height: 98px;
  padding: 24px;
  display: flex;
  align-items: center;
}

.act-bg {
  background: #f6f6f6;
}

.pic {
  width: 50px;
  height: 50px;
  border-radius: 25px;
  /* margin-right: 8px; */
}

.list-right {
  display: flex;
  flex-direction: column;
  height: 50px;
  justify-content: space-between;
  margin-left: 8px;
  width: 100%;
}

.list-right-top {
  display: flex;
  justify-content: space-between;
}

.h {
  font-weight: bold;
}

.time {
  color: #ffffff;
  width: 136px;
  height: 28px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 2px 2px 2px 2px;
  line-height: 28px;
  font-size: 14px;
  text-align: center;
  margin-top: 29px;
  /* opacity: 0.2; */
}

.chat-desc {
  width: 100%;
  /* height: 50px; */
  display: flex;
  align-items: center;
  padding: 0 23px;
  margin-top: 32px;
}

.chat-desc .avapic {
  width: 44px;
  height: 44px;
  border-radius: 22px;
}

.chat-desc .text-box {
  font-size: 16px;
  background: #ffffff;
  padding: 9px 8px;
  margin-left: 16px;
  border-radius: 2px;
}

.chat-desc .text-boxs {
  font-size: 16px;
  background: rgba(85, 154, 255, 1);
  color: #ffffff;
  padding: 9px 8px;
  margin-right: 16px;
  border-radius: 2px;
}

.right {
  flex-direction: row-reverse;
}

.set-box {
  display: flex;
  align-items: center;
}

.set-img-box {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 23px;
  margin-top: 12px;
  cursor: pointer;
}

.set-img-box img {
  width: 24px;
  height: 24px;
}

.btn-box {
  display: flex;
  height: 112px;
  align-items: flex-end;
  padding-right: 12px;
}

.btn-box textarea {
  width: 765px;
  height: 100%;
  border: none;
  background: #f3f3f3;
  resize: none;
  padding-left: 24px;
  padding-top: 10px;
}

/* .el-input{
    height: 100%;
} */
.btn-box .btn {
  width: 106px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  color: #333333;
  background: #fee60f;
  border-radius: 4px;
  margin-left: 12px;
}

.hide {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  filter: alpha(opacity=0);
  opacity: 0;
  cursor: inherit;
  display: none;
}

.img-style {
  max-width: 350px;
}

.margin-l-12 {
  margin-left: 12px;
}

.margin-r-12 {
  margin-right: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/chat.vue